(function(window, document, mL_config, mL, mL_errors, mL_events) {
    "use strict";

    var key = 'last_script';

    if (!mL_config) throw new Error('The mL_config global is not available');
    if (!mL_errors) throw new Error('The mL_errors global is not available');
    if (!mL) throw new Error('The mL global is not available');

    var _params = mL.params;

    if (mL_config.ver) mL.ver = mL_config.ver;

    function delay_load(id) {
        window.setTimeout(function() {
            mL[id].init();
        }, mL_config.tags[id] || 0);
    }

    function ml_init(no_delay) {

        if (_params.select) {
            try {
                mL.menu.select(_params.select);
                mL.menu.open();
            } catch (err) {
                mL_errors(err);
            }
        }

        if (_params.offer) {
            try {
                document.getElementById('mLmodal').setAttribute('class', 'ng-scope active');
            } catch (err) {
                mL_errors(err);
            }
        } else if (_params.show && _params.show === 'holiday' && tjb && tjb.toggleMsg) {
            try {
                tjb.toggleMsg();
            } catch (err) {
                mL_errors(err);
            }
        }

        if (mL.no || mL_config.do_not_track || !mL_config.tags) return;

        for (var n in mL_config.tags) {
            if (mL_config.tags.hasOwnProperty(n) && mL[n] && mL[n].init) {
                if (no_delay) {
                    mL[n].init();
                } else {
                    delay_load(n);
                }
            }
        }

    }

    window.addEventListener("load", function(){
        ml_init(mL_config.is_checkout);
        if (mL_config.DEBUG) console.log('versions', mL.version());
    }, false);

    mL_events.subscribe('page', function(msg, data) {
        var shop = data.shop;
        var curr_shop = mL.user.shop();
        var new_shop;

        if (shop && shop.name && shop.color && shop.lp_code && shop.urlc) {
            new_shop = { 'shop_name': shop.name, 'shop_urlc': shop.urlc, 'shop_lp_code': shop.lp_code, 'shop_color': shop.color, 'shop_type': shop.type };
            if (!curr_shop) {
                if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - missing current shop');
                return mL.user.shop(new_shop);
            } else if (JSON.stringify(curr_shop) !== JSON.stringify(new_shop)) {
                if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - updated');
                return mL.user.shop(new_shop);
            } else {
                if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - no update required');
                return false;
            }
        }
        if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - no valid shop object');
        return false;

    });


    //console.log('this_page', window.this_page);
    //console.log('tjb', window.tjb);


}(window, document, window.mL_config, window.mL, window.mL_errors, window.mL_events));